import { faArrowsRepeat, faFileSlash, faInfoCircle, faMoneyFromBracket } from '@fortawesome/pro-light-svg-icons'
import { sellTicketStatusInversed, sellTicketTypeInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import { Fragment, useCallback } from 'react'
import { ButtonPrimary, ButtonRed } from '../../../../../../../../../../baseComponents/Button'
import TwinIcon, { TwinIconToolTip } from '../../../../../../../../../../baseComponents/TwinIcon'
import { InputTableURLsTable } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import { SellTicketButtonsProps, SetTPVCompleteDataTy, TPVOrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllWorkingCenters } from '../../../../../../../../../../utils/reducers/getters'
import { parsedTicketTableData } from '../../../../../functions'
import ModalPaymentMethodTPV from '../../../ModalPaymentMethodTPV'
import ModalPaymentMethodInfoTPV from '../../../ModalPaymentMethodTPV/ModalPaymentMethodInfoTPV'
import ModalWarehouseTPV from '../../../ModalWarehouseTPV'
import ModalCancelSellTicketPartial from '../ModalCancelSellTicketPartial'
import ModalDeliverSellTicketPartialCharged from '../ModalDeliverSellTicketPartialCharged'

interface SellTicketPartialChargedStepButtonsProps extends SellTicketButtonsProps {
    inputTableURLs: InputTableURLsTable
    completeData: TPVOrderData
    setCompleteData: SetTPVCompleteDataTy
}

const SellTicketPartialChargedStepButtons: React.FC<SellTicketPartialChargedStepButtonsProps> = ({ ...rest }) => {
    const sameWorkingCenter = parseInt(String(rest.completeData?.header?.WorkingCenterId)) === parseInt(String(rest.completeData?.cashRegister?.WorkingCenterId))
    return (
        <div className='flex flex-row bg-white product_ticket_buttons overflow-hidden'>
            <RestartSellTicketButton {...rest} />
            <ProcessSellTicketButton {...{ ...rest, sameWorkingCenter }} />
            <CancelSellTicketButton {...{ ...rest, sameWorkingCenter }} />
        </div>
    )
}

interface ProcessSellTicketButtonProps extends ProcessSellTicketButtonLogicProps {
    sameWorkingCenter?: boolean
}

const ProcessSellTicketButton: React.FC<ProcessSellTicketButtonProps> = ({ ...rest }) => {
    const { openModal, setOpenModal, myOnSubmit, handleProcessSellTicket, isTotalPayed } = useProcessSellTicketButtonLogic({ ...rest })
    const { t } = useTwinTranslation()
    const buttonTitle = isTotalPayed ? t('deliver', 'Entregar') : t('charge', 'Cobrar')
    return (
        <Fragment>
            <ButtonPrimary className={'flex-auto flex items-center justify-center ticket_button_no_border w-1/2 ' + (rest.sameWorkingCenter ? 'save_ticket_button_parent' : '')} onClick={handleProcessSellTicket} disabled={!rest.sameWorkingCenter}>
                <TwinIcon icon={faMoneyFromBracket} className='mr-8 text-white regular20 ' />
                <span>{buttonTitle}</span>
                {!rest.sameWorkingCenter ? <TwinIconToolTip positionStrategy='fixed' className='ml-20' icon={faInfoCircle} message={t('notProcessTicketBecauseNotSameWorkingCenter', 'No puedes procesar este ticket debido a que no es del mismo centro de trabajo')} id={rest.completeData?.header?.id + '-cancel'} classNameTooltip='max-w-300' /> : null}
            </ButtonPrimary>
            {openModal?.type === 'create' ? <ModalPaymentMethodTPV completeData={rest.completeData} setOpenModal={setOpenModal} url={'/api/app/order/tpv/sellTicket/chargeSellTicket'} onSubmit={()=>{}} isRefund={false} allRowData={openModal.allRowData} /> : null}
            {openModal?.type === 'edit' ? <ModalDeliverSellTicketPartialCharged setOpened={() => { }} onSubmit={() => { }} allRowData={openModal.allRowData} setOpenModal={setOpenModal} {...rest} /> : null}
            {openModal?.type === 'delete' ? <ModalPaymentMethodInfoTPV setOpenModal={setOpenModal} allRowData={openModal?.allRowData} inputTableURLs={rest.inputTableURLs} handleCloseModal={myOnSubmit} /> : null}
        </Fragment>
    )
}

interface ProcessSellTicketButtonLogicProps extends SellTicketPartialChargedStepButtonsProps { }

const useProcessSellTicketButtonLogic = ({ setCompleteData, completeData }: ProcessSellTicketButtonLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const isTotalPayed = completeData?.header?.status === sellTicketStatusInversed['partialCharged'] && completeData?.header?.type === sellTicketTypeInversed['sell'] && parseFloat(String(completeData?.header?.total_to_pay)) === 0
    const handleProcessSellTicket = useCallback(async () => {
        if (isTotalPayed) {
            setOpenModal({ type: 'edit', allRowData: { id: completeData?.header?.id, CurrencyId: completeData?.header?.CurrencyId, myTotalPayments: { total: completeData?.header?.total_payed }, headerData: completeData.header, OrderId: completeData?.header?.id } })
        } else {
            setOpenModal({ type: 'create', allRowData: { id: completeData?.header?.id } })
        }
    }, [setOpenModal, completeData, isTotalPayed])

    const myOnSubmit = useCallback(async () => {
        setCompleteData((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.lastProductIndex = null
            copyOld.header = {}
            copyOld.tableData = []
            copyOld.Customer = {}
            delete copyOld.selectedTableData
            parsedTicketTableData(copyOld)
            return copyOld
        })
    }, [setCompleteData])
    return { openModal, setOpenModal, myOnSubmit, handleProcessSellTicket, isTotalPayed }
}


interface RestartSellTicketButtonProps extends RestartSellTicketButtonLogicProps {
}

const RestartSellTicketButton: React.FC<RestartSellTicketButtonProps> = ({ ...rest }) => {
    const { loading, handleRestartSellTicket } = useRestartSellTicketButtonLogic({ ...rest })
    return (
        <ButtonPrimary className={'flex-auto flex items-center justify-center w-1/2 ticket_button_border_left charge_ticket_button_parent'} onClick={handleRestartSellTicket} >
            <TwinIcon icon={faArrowsRepeat} className={'mr-8 text-white regular20 ' + (loading ? 'hidden' : '')} />
            <span>{loading ?
                <TwinTrans transKey='processingDotsv2' >Procesando...</TwinTrans>
                : <TwinTrans transKey='newTicket'>Nuevo ticket</TwinTrans>}
            </span>
        </ButtonPrimary>
    )
}

interface RestartSellTicketButtonLogicProps extends SellTicketPartialChargedStepButtonsProps {
    setCompleteData: SetTPVCompleteDataTy
}

const useRestartSellTicketButtonLogic = ({ setCompleteData }: RestartSellTicketButtonLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const handleRestartSellTicket = useCallback(async () => {
        startLoading?.()
        setCompleteData((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.lastProductIndex = null
            copyOld.header = {}
            copyOld.tableData = []
            delete copyOld.selectedTableData
            copyOld.Customer = {}
            parsedTicketTableData(copyOld)
            return copyOld
        })
        endLoading?.()
    }, [startLoading, endLoading, setCompleteData])
    return { loading, handleRestartSellTicket }
}

interface CancelSellTicketButtonProps extends CancelSellTicketButtonLogicProps {
    sameWorkingCenter?: boolean
}

const CancelSellTicketButton: React.FC<CancelSellTicketButtonProps> = ({ ...rest }) => {
    const { loading, handleCancelSellTicket, openModal, setOpenModal, handleOnAcceptFnc, isNotPayed } = useCancelSellTicketButtonLogic({ ...rest })
    const { t } = useTwinTranslation()
    return (
        <Fragment>
            <ButtonRed className={'flex-auto flex items-center justify-center w-1/2  ticket_button_border_right ' + (rest.sameWorkingCenter ? 'red_ticket_button_parent' : '')} onClick={handleCancelSellTicket} disabled={!rest.sameWorkingCenter}>
                <TwinIcon icon={faFileSlash} className={'mr-8 text-white regular20 ' + (loading ? 'hidden' : '')} />
                <span>{loading ?
                    <TwinTrans transKey='processingDotsv2' >Procesando...</TwinTrans>
                    : <TwinTrans transKey='cancel'>Cancelar</TwinTrans>}
                </span>
                {!rest.sameWorkingCenter ? <TwinIconToolTip positionStrategy='fixed' className='ml-20' icon={faInfoCircle} message={t('notProcessTicketBecauseNotSameWorkingCenter', 'No puedes procesar este ticket debido a que no es del mismo centro de trabajo')} id={rest.completeData?.header?.id + '-cancel'} classNameTooltip='max-w-300' /> : null}
            </ButtonRed>
            {openModal?.type === 'create' && openModal?.allRowData?.type === 'Warehouse' ? <ModalWarehouseTPV setOpenModal={setOpenModal} allRowData={openModal?.allRowData} handleOnAcceptFnc={isNotPayed ? handleOnAcceptFnc : undefined} /> : null}
            {openModal?.type === 'create' && openModal?.allRowData?.type !== 'Warehouse' ? <ModalPaymentMethodTPV completeData={rest.completeData} setOpenModal={setOpenModal} url={''} onSubmit={() => { }} isRefund={true} openModal={openModal} allRowData={openModal?.allRowData} isReservedRefund={true} /> : null}
            {openModal?.type === 'edit' ? <ModalCancelSellTicketPartial setOpened={() =>{}} onSubmit={() => {}} allRowData={openModal.allRowData} setOpenModal={setOpenModal} {...rest} /> : null}
            {openModal?.type === 'delete' ? <ModalPaymentMethodInfoTPV setOpenModal={setOpenModal} allRowData={openModal?.allRowData} isRefund={true} handleCloseModal={() => { rest.getCompleteData(rest.completeData?.header?.id) }} inputTableURLs={rest.inputTableURLs} isReservedRefund={true} /> : null}
        </Fragment>
    )
}

interface CancelSellTicketButtonLogicProps extends SellTicketPartialChargedStepButtonsProps {
}

const useCancelSellTicketButtonLogic = ({ completeData }: CancelSellTicketButtonLogicProps) => {
    const isNotPayed = completeData?.header?.status === sellTicketStatusInversed['partialCharged'] && completeData?.header?.type === sellTicketTypeInversed['reserved'] && parseFloat(String(completeData?.header?.total_payed)) === 0

    const { endLoading, loading, startLoading } = useIsLoading()
    const { openModal, setOpenModal } = useEditDeleteModal()
    const workingCenters = getAllWorkingCenters()

    const handleOnAcceptFnc = useCallback((allRowData: RowData) => {
        setOpenModal({ type: 'edit', allRowData: { ...allRowData, values: { SellTicketId: completeData?.header?.id, CashRegisterId: completeData.cashRegister?.id }, Customer: completeData?.header?.Customer, CurrencyId: completeData?.header?.CurrencyId, myTotalPayments: { total: 0 }, WarehouseId: allRowData?.WarehouseId, WorkingCenterId: completeData?.cashRegister?.WorkingCenterId } })
    }, [completeData, setOpenModal])
    const handleCancelSellTicket = useCallback(async () => {
        startLoading?.()
        const warehouses = workingCenters?.[completeData?.cashRegister?.WorkingCenterId || 0]?.Warehouses
        if (warehouses?.length) {
            const myData: TwinDictionary = completeData
            if (warehouses && warehouses.length > 1) {
                myData['type'] = 'Warehouse'
            } else {
                myData['type'] = 'PaymentMethods'
                myData['WarehouseId'] = warehouses?.[0]?.id || null
            }
            if (isNotPayed && myData.type === 'PaymentMethods'){
                handleOnAcceptFnc(myData)
            }else{
                setOpenModal({ type: 'create', allRowData: { ...myData } })
            }
        }
        endLoading?.()
    }, [workingCenters, setOpenModal, completeData, startLoading, endLoading, handleOnAcceptFnc, isNotPayed])

    return { loading, openModal, handleCancelSellTicket, setOpenModal, handleOnAcceptFnc, isNotPayed }
}

export default SellTicketPartialChargedStepButtons